import React, { useEffect, useState } from "react";
import "./InternetChecker.scss"; // ✅ optional if you want to style separately

export default function InternetChecker() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return (
    <>
      {!isOnline && (
        <div className="internet-popup">⚠️ Internet Disconnected</div>
      )}
    </>
  );
}
